import common from '../common';
import Text from './Text';

export default class WarningDialog extends PIXI.Container {
	constructor(icon = null) {
		super();

		this.signals = {
			confirm: new P3.utils.MiniSignal(),
			deny: new P3.utils.MiniSignal(),
		};

		this._iconSprite = null;
		this._background = null;
		this._bodyLabel = null;
		this._titleLabel = null;
		this._confirmButton = null;
		this._confirmLabel = null;
		this._cancelButton = null;
		this._cancelLabel = null;

		this.init(icon);
	}

	init(icon) {
		this._background = new PIXI.NineSlicePlane(P3.assets.texture('panel_scenario_9slice'), 40, 100, 40, 40);
		this._background.width = 520;
		this._background.height = 600;
		this._background.position.set(this._background.width * -0.5, this._background.height * -0.5);
		this.addChild(this._background);

		this._titleLabel = new Text('gui.dialog.warning', { font: '32px', fontWeight: 'bold', align: 'center', tint: 0xffffff });
		this._titleLabel.position.set(50, 40);
		this._background.addChild(this._titleLabel);

		if (icon) {
			this._iconSprite = new PIXI.Sprite(P3.assets.texture(icon));
			this._iconSprite.anchor.set(0.5, 0);
			this._iconSprite.position.set(this._background.width * 0.5, 100);
			this._background.addChild(this._iconSprite);
		}

		this._bodyLabel = new Text('', { font: '30px', align: 'left', tint: 0x0, wordWrap: true, wordWrapWidth: this._background.width - 100 });
		this._bodyLabel.position.set(50, this._iconSprite ? this._iconSprite.y + this._iconSprite.height + 25 : 100);
		this._background.addChild(this._bodyLabel);

		this._confirmButton = common.buttonFactory.createButton({
			normal: { textureName: 'btn_blue_fill_large_9slice_out', width: 200, height: 75, left: 35, top: 35, right: 35, bottom: 35 },
			over: { textureName: 'btn_blue_fill_large_9slice_over', width: 200, height: 75, left: 35, top: 35, right: 35, bottom: 35 },
		});
		this._confirmButton.position.set(this._background.width * 0.5 + this._confirmButton.width * 0.5 + 10, this._bodyLabel.y + this._bodyLabel.height + 75);
		this._confirmButton.signals.click.add(this.onConfirmButtonClick, this);
		this._background.addChild(this._confirmButton);

		this._confirmLabel = new Text('gui.general.options.yes', { font: '32px', fontWeight: 'bold', align: 'left', tint: 0xFFFFFF, maxWidth: 180 });

		this._confirmLabel.anchor.set(0.5);
		this._confirmButton.animation.addChild(this._confirmLabel);
		this._confirmButton.accessibleTitle = this._confirmLabel.text;

		this._cancelButton = common.buttonFactory.createButton({
			normal: { textureName: 'btn_black_outline_9slice_out', width: 200, height: 75, left: 35, top: 35, right: 35, bottom: 35 },
			over: { textureName: 'btn_black_outline_9slice_out', width: 200, height: 75, left: 35, top: 35, right: 35, bottom: 35 },
		});
		this._cancelButton.position.set(this._background.width * 0.5 - this._cancelButton.width * 0.5 - 10, this._bodyLabel.y + this._bodyLabel.height + 75);
		this._cancelButton.signals.click.add(this.onCancelButtonClick, this);
		this._background.addChild(this._cancelButton);

		this._cancelLabel = new Text('gui.general.options.no', { font: '32px', fontWeight: 'bold', align: 'left', tint: 0x0, maxWidth: 180 });
		this._cancelLabel.anchor.set(0.5);
		this._cancelButton.animation.addChild(this._cancelLabel);

		this._cancelButton.accessibleTitle = this._cancelLabel.text;

		this.resize();
	}

	onConfirmButtonClick() {
		this.signals.confirm.dispatch();
		this.destroy();
	}

	onCancelButtonClick() {
		this.signals.deny.dispatch();
		this.destroy();
	}

	toggleCancelButton(state) {
		this._cancelButton.visible = state;

		if (state) {
			this._confirmButton.position.set(this._background.width * 0.5 + this._confirmButton.width * 0.5 + 10, this._bodyLabel.y + this._bodyLabel.height + 75);
		} else {
			this._confirmButton.position.set(this._background.width * 0.5, this._bodyLabel.y + this._bodyLabel.height + 75);
		}

		return this;
	}

	resize() {
		this._confirmButton.y = this._bodyLabel.y + this._bodyLabel.height + 75;
		this._cancelButton.y = this._bodyLabel.y + this._bodyLabel.height + 75;

		this._background.height = this._confirmButton.y + this._confirmButton.height + 25;
	}

	/**
	 * @param v {String} The text to assign to the bodyLabel
	 */
	set body(v) {
		this._bodyLabel.text = v;
		this.resize();
	}

	get body() {
		return this._bodyLabel.text;
	}

	set confirmLabel(v) {
		this._confirmLabel = v;
		this._confirmButton.accessibleTitle = this._confirmLabel.text;
	}

	get confirmLabel() {
		return this._confirmLabel;
	}

	set canceLabel(v) {
		this._canceLabel = v;
		this._cancelButton.accessibleTitle = this._cancelLabel.text;
	}

	get canceLabel() {
		return this._canceLabel;
	}
}
